<template>
    <el-card class="box-card mt-2 booking-list-box" @click="drawer = true;reloaddata()" >

        <el-space alignment="flex-start" wrap>
            <el-avatar shape="square" :size="50" :src="user.image" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Details</el-text>
                <el-text class="mx-1" size="small" tag="b">{{user.name}} <span v-if="user.doj!=null"> / {{ formatDate(user.doj) }}</span> <span v-if="user.doe!=null"> to {{ formatDate(user.doe)}}</span></el-text>
                <el-text class="mx-1" size="small" tag="b">{{user.email}} | {{user.mobile}}</el-text>

            </el-space>

            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Department</el-text>
                <el-text class="mx-1" size="small" tag="b">{{user.department}}</el-text>
            </el-space>
            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Designation</el-text>
                <el-text class="mx-1" size="small" tag="b">{{user.designation}}</el-text>
            </el-space>
            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Reporting</el-text>
                <el-text class="mx-1" size="small" tag="b">{{user.reporting}}</el-text>
            </el-space>

            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Services</el-text>
                <el-text class="mx-1" size="small"> <el-tag class="mx-1" size="small" v-for="service in user.services">{{service}}</el-tag></el-text>
            </el-space>
            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Permissions</el-text>
                <el-text class="mx-1" size="small"><el-tag class="mx-1" size="small" v-for="permission in user.permissions">{{permission}}</el-tag></el-text>
            </el-space>
            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Status</el-text>
                <el-tag class="mx-1" size="small" type="success" v-if="user.status==1">Active</el-tag><el-tag class="mx-1" size="small" type="danger" v-else>In Active</el-tag>
            </el-space>
            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Destination Regions</el-text>
                <el-popover
                    placement="top-start"
                    title="Destination Regions"
                    :width="200"
                    trigger="hover"

                >
                    <template #reference>
                        <el-tag class="mx-1" size="small" type="info" >{{user.dest_team.length}}</el-tag>
                    </template>
                    <p class="mb-0" v-for="dest in user.dest_team">{{dest}}</p>
                </el-popover>
            </el-space>
            <el-divider direction="vertical" />
            <el-space direction="vertical" alignment="flex-start" :size="0">
                <el-text class="mx-1" size="small" type="info">Destinations</el-text>
                <el-popover
                    placement="top-start"
                    title="Destinations"
                    :width="200"
                    trigger="hover"

                >
                    <template #reference>
                        <el-tag class="mx-1" size="small" type="info" >{{user.destinations.length}}</el-tag>
                    </template>
                    <p class="mb-0" v-for="dest in user.destinations">{{dest}}</p>
                </el-popover>
            </el-space>


        </el-space>


    </el-card>


    <el-drawer  v-model="drawer" direction="rtl" size="50%">
        <template #header>
            <h4>Edit User</h4>
        </template>
        <template #default>
            <div >
                <el-form
                    label-position="top"
                    ref="ruleFormRef"
                    :model="form"
                    status-icon
                    :rules="rules"
                >
                    <el-row>

                        <el-col :span="24">
                            <el-upload
                                class="avatar-uploader"
                                :action="'/user/imageupload?id='+user.id"
                                :show-file-list="false"
                                :on-success="imageuploaded"
                                :before-upload="beforeAvatarUpload"
                                :headers="{ 'X-CSRF-TOKEN': csrf_token}"
                            >
                                <el-avatar shape="square" :size="100" :src="user.image" />
                            </el-upload>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Name" prop="name">

                                <el-input  v-model="form.name"  placeholder="Enter Name" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Email" class="ml-2" prop="email">
                                <el-input   v-model="form.email"  placeholder="Enter Email" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Phone" class="ml-2" prop="mobile">
                                <el-input   v-model="form.mobile"  placeholder="Enter Phone" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Password"  prop="password">
                                <el-input   v-model="form.password"  placeholder="Enter New Password" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Department"  class="ml-2" prop="department">
                                <el-select v-model="form.department"  placeholder="Select"  style="width:100%" disabled>
                                    <el-option
                                        v-for="item in departments"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="ml-2" label="Designation"   prop="designation">
                                <el-select v-model="form.designation" @change="rolechange()"  placeholder="Select"  style="width:100%" :disabled="form.designation=='admin'">
                                    <el-option
                                        v-for="item in designations"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="form.designation!='management' && form.designation!='manager' && form.designation!='admin'">
                            <el-form-item label="Under Working"   prop="underworking">
                                <el-select v-model="form.underworking"  placeholder="Select"  style="width:100%" >
                                    <el-option
                                        v-for="item in underworkings"
                                        :key="item.id"
                                        :label="item.name+' ('+item.designation+')'"
                                        :value="item.id"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="form.designation!='management' && form.designation!='manager' && form.designation!='admin'">
                            <el-form-item class="ml-2" label="Enquiry Assign Limit"   prop="daily_assign_limit">
                                <el-input type="number" min="0"  v-model="form.daily_assign_limit"  placeholder="Enter Limit" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="form.department=='Sales'">
                            <el-form-item class="ml-2" label="Target"   prop="target">
                                <el-input type="number" min="0"  v-model="form.target"  placeholder="Enter Target" ></el-input>
                            </el-form-item>
                        </el-col>



                        <el-col :span="24">
                            <el-form-item label="Destination Regions"   prop="dest_team">
                                <el-select-v2
                                    v-model="form.dest_team"
                                    filterable
                                    :options="destinationtypes"
                                    placeholder="Please select"
                                    style="width: 100%"
                                    multiple
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Destinations"   prop="destinations">
                                <el-select-v2
                                    v-model="form.destinations"
                                    filterable
                                    :options="destinations"
                                    placeholder="Please select"
                                    style="width: 100%"
                                    multiple
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" >
                            <el-form-item label="Services" class="text-bold" >
                                <div>
                                    <el-checkbox v-model="form.package_manage" label="Package" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="form.flight_manage" label="Flight" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="form.hotel_manage" label="Hotel" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="form.visa_manage" label="Visa" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="form.cruise_manage" label="Cruise" :true-label="1" :false-label="0"  size="large" />

                                </div>
                              </el-form-item>
                        </el-col>

                        <el-col :span="24" >
                            <el-form-item label="Permissions" class="text-bold" v-if="authuser.is_fullaccess==1" >

                                    <el-checkbox v-model="form.aux" label="AUX" :true-label="1" :false-label="0"  size="large" />

                                    <el-checkbox v-model="form.outside_access" label="Outside Access" :true-label="1" :false-label="0"  size="large" />

                                    <el-checkbox v-model="form.query_assign_access" label="Enquiry Assign Access" :true-label="1" :false-label="0"  size="large" />
                                    <el-checkbox v-model="form.users_manage" v-if="form.designation=='manager'" label="Users Manage" :true-label="1" :false-label="0"  size="large" />


                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item  label="Status"   prop="status">
                                <el-select v-model="form.status" :disabled="user.children.length>0"   placeholder="Select"  style="width:100%" >
                                    <el-option
                                        v-for="item in statuses"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item  class="ml-2" label="Expert/Fresher"   prop="status">
                                <el-select v-model="form.expert"    placeholder="Select"  style="width:100%" >
                                    <el-option
                                        v-for="item in expertes"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item  class="ml-2" label="DOJ"   prop="doj">
                                <el-date-picker
                                    v-model="form.doj"
                                    type="date"
                                    placeholder="Pick a Date"
                                    format="DD/MMM/YYYY"
                                    value-format="YYYY-MM-DD"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" v-if="form.status==0">
                            <el-form-item  class="ml-2" label="DOE"   prop="doe" >
                                <el-date-picker
                                    v-model="form.doe"
                                    type="date"
                                    placeholder="Pick a Date"
                                    format="DD/MMM/YYYY"
                                    value-format="YYYY-MM-DD"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>



                </el-form>
            </div>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="drawer = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()">Save</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElPopover,
    ElSelectV2,
    ElIcon,
    ElUpload,
    ElCheckbox,
    ElInput,
    ElDrawer,
    ElText,
    ElSpace,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElFormItem,
    ElForm,
    ElCol,
    ElRow,
    ElButton,
    ElCard,
    ElTag,
    ElAvatar,
    ElDivider,
    ElSkeleton,
    ElMessage,
    ElLoading
} from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'

let loadingInstance = null;

export default {
    name: "ListCard",
    components: { ElPopover,ElSelectV2,ElIcon,ElUpload,ElCheckbox,ElInput,ElDrawer,ElText,ElSpace,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    props:{
        user: {
            type: Object,
            default () {
                return null
            }
        },
        users: {
            type: Object,
            default () {
                return null
            }
        },
        authuser: {
            type: Object,
            default () {
                return null
            }
        },
        departments: {
            type: Object,
            default () {
                return []
            }
        },
        designations: {
            type: Object,
            default () {
                return []
            }
        },
        destinationtypes: {
            type: Object,
            default () {
                return []
            }
        },
        destinations: {
            type: Object,
            default () {
                return []
            }
        },
    },
    emits: ['saved'],
    created(){
        this.csrf_token=window.csrf_token;
    },
    data() {
        return {
            csrf_token:null,
            loading: false,
            drawer:false,
            form:{
                name : "",
                email:"",
                mobile:"",
                password:"",
                department:"",
                designation:"",
                underworking:0,
                package_manage:0,
                flight_manage:0,
                hotel_manage:0,
                visa_manage:0,
                cruise_manage:0,
                outside_access:0,
                query_assign_access:0,
                users_manage:0,
                status:0,
                aux:0,
                dest_team:[],
                destinations:[],
                daily_assign_limit:0,
                target:0,
                expert:0,
                doj:null,
                doe:null
            },
            underworkings:[],
            rules:{
                name: [{ required: true, trigger: 'change', message:'' }],
                email: [{ required: true, trigger: 'change', message:'' }],
                mobile: [{ required: true, trigger: 'change', message:'' }],
                department: [{ required: true, trigger: 'change', message:'' }],
                designation: [{ required: true, trigger: 'change', message:'' }],
                underworking: [{ required: true, trigger: 'change', message:'' }],
                daily_assign_limit: [{ required: true, trigger: 'change', message:'' }],
                target: [{ required: true, trigger: 'change', message:'' }],
                doj: [{ required: true, trigger: 'change', message:'' }],
                doe: [{ required: true, trigger: 'change', message:'' }],
            },
            statuses:[
                {
                    value:1,
                    label:'Active'
                },
                {
                    value:0,
                    label:'InActive'
                },
            ],
            expertes:[
                {
                    value:1,
                    label:'Expert'
                },
                {
                    value:0,
                    label:'Fresher'
                }
            ],
        }
    },
    methods: {
        formatDate(dateStr) {
            return moment(dateStr).format('D MMM YY')
        },
        reloaddata() {
            this.form.name=this.user.name;
            this.form.email=this.user.email;
            this.form.mobile=this.user.mobile;
            this.form.department=this.user.department;
            this.form.designation=this.user.designation;
            this.form.underworking=this.user.underworking;
            this.form.package_manage=this.user.package_manage;
            this.form.flight_manage=this.user.flight_manage;
            this.form.hotel_manage=this.user.hotel_manage;
            this.form.visa_manage=this.user.visa_manage;
            this.form.cruise_manage=this.user.cruise_manage;
            this.form.outside_access=this.user.outside_access;
            this.form.query_assign_access=this.user.query_assign_access;
            this.form.users_manage=this.user.users_manage;
            this.form.status=this.user.status;
            this.form.aux=this.user.aux;
            this.form.dest_team=this.user.dest_team;
            this.form.destinations=this.user.destinations;
            this.form.daily_assign_limit=this.user.daily_assign_limit;
            this.form.target=this.user.target;
            this.form.expert=this.user.expert;
            this.form.doj=this.user.doj;
            this.form.doe=this.user.doe;
            this.form.password="";
            this.departchange();
        },
        rolechange(){



            if(this.form.designation=="management" || this.form.designation=="manager"){
                this.form.underworking=null;
            }
            else{
                this.form.underworking="";
            }

            this.departchange();


        },
        departchange(){
            if(this.form.designation=="manager"){
                this.underworkings=[];
            }
            else if(this.form.designation=="tl"){
                this.underworkings=this.users.filter(item => (( item.designation=="manager") && (item.department==this.form.department)));
            }
            else if(this.form.designation=="sme"){
                this.underworkings=this.users.filter(item => ((item.designation=="manager" || item.designation=="tl") && (item.department==this.form.department)));
            }
            else if(this.form.designation=="agent"){
                this.underworkings=this.users.filter(item => (( item.designation=="manager" || item.designation=="tl" || item.designation=="sme") && (item.department==this.form.department)));
            }
            else{
                this.underworkings=[];
            }


        },
        submitForm(){
            var formEl=this.$refs.ruleFormRef;
            let currentObj = this;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    currentObj.loading=true;
                    loadingInstance = ElLoading.service({ fullscreen: true });
                    axios.put('/users/'+currentObj.user.id,currentObj.form).then(function (response) {

                        currentObj.loading=false;
                        ElMessage({
                            showClose: true,
                            message: 'User Updated Succesfully.',
                            type: 'success',
                        });
                        currentObj.drawer=false;
                        currentObj.$emit('saved');

                            loadingInstance.close()


                    })
                        .catch(function (error) {
                            currentObj.loading=false;

                                loadingInstance.close()

                        });
                } else {

                    return false
                }
            })
        },
        imageuploaded(){
            ElMessage({
                showClose: true,
                message: 'User Image Updatd Succesfully.',
                type: 'success',
            });
            this.drawer=false;
            this.$emit('saved');
            loadingInstance.close()
        },
        beforeAvatarUpload(rawFile) {
            if (rawFile.type !== 'image/jpeg') {
                ElMessage.error('Avatar picture must be JPG format!')
                return false
            } else if (rawFile.size / 1024 / 1024 > 2) {
                ElMessage.error('Avatar picture size can not exceed 2MB!')
                return false
            }
            loadingInstance = ElLoading.service({ fullscreen: true });
            return true
        }

    }
}
</script>

<style scoped>

</style>
